import { ProductImageRenditions } from "@utils/enums";

// Call To Action List
export const CTAListRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.MINI,
    xs: ProductImageRenditions.MINI,
    sm: ProductImageRenditions.MINI,
    md: ProductImageRenditions.MINI,
    lg: ProductImageRenditions.MINI,
    xl: ProductImageRenditions.MINI,
};

export const GiftCardRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.SM,
    xs: ProductImageRenditions.MD,
    sm: ProductImageRenditions.MD,
    md: ProductImageRenditions.SM,
    lg: ProductImageRenditions.SM,
    xl: ProductImageRenditions.SM,
};

// Shopping Cart Items on page
export const ShoppingCartItemRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.MINI,
    xs: ProductImageRenditions.MINI,
    sm: ProductImageRenditions.XS,
    md: ProductImageRenditions.XS,
    lg: ProductImageRenditions.MINI,
    xl: ProductImageRenditions.XS,
};

// Shopping Cart Dropdown
export const ShoppingCartSummaryRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.MINI,
    xs: ProductImageRenditions.MINI,
    sm: ProductImageRenditions.MINI,
    md: ProductImageRenditions.SM,
    lg: ProductImageRenditions.MINI,
    xl: ProductImageRenditions.MINI,
};

// Add To Cart Model
export const AddToCartModelRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.XS,
    xs: ProductImageRenditions.SM,
    sm: ProductImageRenditions.SM,
    md: ProductImageRenditions.SM,
    lg: ProductImageRenditions.SM,
    xl: ProductImageRenditions.SM,
};

// Order Confirmation Page
export const OrderOverviewItemRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.MINI,
    xs: ProductImageRenditions.MINI,
    sm: ProductImageRenditions.SM,
    md: ProductImageRenditions.XS,
    lg: ProductImageRenditions.MINI,
    xl: ProductImageRenditions.XS,
};

// My Orders Page
export const OrderItemRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.MINI,
    xs: ProductImageRenditions.XS,
    sm: ProductImageRenditions.SM,
    md: ProductImageRenditions.MINI,
    lg: ProductImageRenditions.MINI,
    xl: ProductImageRenditions.XS,
};

// My Order Detail Page
export const OrderDetailItemRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.XS,
    xs: ProductImageRenditions.SM,
    sm: ProductImageRenditions.SM,
    md: ProductImageRenditions.XS,
    lg: ProductImageRenditions.XS,
    xl: ProductImageRenditions.SM,
};

// ProductSliders
export const ProductSlidersRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.SM,
    xs: ProductImageRenditions.SM,
    sm: ProductImageRenditions.SM,
    md: ProductImageRenditions.SM,
    lg: ProductImageRenditions.SM,
    xl: ProductImageRenditions.SM,
};

// Configurable product only has 1 rendition so these values are just fixed
export const ConfigurableProductRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.SM,
    xs: ProductImageRenditions.SM,
    sm: ProductImageRenditions.SM,
    md: ProductImageRenditions.SM,
    lg: ProductImageRenditions.SM,
    xl: ProductImageRenditions.SM,
};

// ProductTile
export const ProductTileRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.MD,
    xs: ProductImageRenditions.MD,
    sm: ProductImageRenditions.MD,
    md: ProductImageRenditions.MD,
    lg: ProductImageRenditions.MD,
    xl: ProductImageRenditions.MD,
};

// ProductSearchTile
export const ProductSearchTileRenditions: Renditions = {
    defaultRendition: ProductImageRenditions.SM,
    xs: ProductImageRenditions.XS,
    sm: ProductImageRenditions.SM,
    md: ProductImageRenditions.SM,
    lg: ProductImageRenditions.SM,
    xl: ProductImageRenditions.SM,
};

export interface Renditions {
    [key: string]: ProductImageRenditions | undefined;
    defaultRendition?: ProductImageRenditions;
    xs?: ProductImageRenditions;
    sm?: ProductImageRenditions;
    md?: ProductImageRenditions;
    lg?: ProductImageRenditions;
    xl?: ProductImageRenditions;
}
